export default __webpack_public_path__ + "static/main-hero-bg-9894bc10d987fc14ab03aba799f0ea2b.webp";